export const ABANDONED_CARTS_URL = "/cart/abandone/data"
